import { apiClient } from '../config';

export default {
  getSmsSchemas (params) {
    return apiClient.get('misc/sms-schemas', { params });
  },
  getAsteriskServers (params) {
    return apiClient.get('asterisk-servers', { params });
  }
};
